import { connect } from 'react-redux';

import { setAdditionalDetailsStatus } from '../pyc-redeem.actions';
import { State } from 'widgets/redeem/root/root.reducers';

import RedemptionAdditionalInfo from '../../redemption/redeem-additional-info/additional-info.component';

import { Dispatch } from 'types/dispatch';
import {
    IRedemptionAdditionalInfoDispatchProps,
    IRedemptionAdditionalInfoStoreProps
} from '../../redemption/redeem-additional-info/additional-info.types';
import { ADDITIONAL_DETAILS_STATUS } from '../pyc-redeem.constants';

const mapStateToProps = (state: State, ownProps: Object): IRedemptionAdditionalInfoStoreProps => ({
    activeLanguageCode: state.language?.activeLanguageCode,
    redeemData: state.redemption?.redeemData,
    additionalFields: state.redemption?.additionalDetailsDefinition ?? [],
    fetching: state.redemption?.fetching ?? false,
    ...ownProps
});

const mapDispatchToProps = (dispatch: Dispatch): IRedemptionAdditionalInfoDispatchProps => ({
    redeemGift: () => {
        dispatch(setAdditionalDetailsStatus(ADDITIONAL_DETAILS_STATUS.COMPLETED));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(RedemptionAdditionalInfo);
